import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import dayjs from "dayjs";
import store from "../store";
import html2pdf from "html2pdf.js";
import { renderPdfApi } from "../apiservice/setting";

const pathSpliter = (path, index) => {
  let divs = path.split("/");
  return divs[index];
};

const authInfoSeter = JSON.parse(localStorage.getItem("auth_info"));
const dateTimeFormat = "DD/MM/YYYY";
const dateWithTimeFormat = "DD MMM Y hh:mm zz a";

const dateFormat = "DD MMM Y";

let cachedAccess = null;
const accessChecker = (accessName) => {
  if (!cachedAccess || cachedAccess.length === 0) {
    const auth = JSON.parse(localStorage.getItem("auth_info"));
    cachedAccess = auth?.company_user_access?.map((x) => x.access) || [];
  }
  return cachedAccess.includes(accessName);
};

const accessList = () => {
  let auth = JSON.parse(localStorage.getItem("auth_info"));
  if (auth) {
    if (auth.access != undefined || auth.access.length != 0) {
      let access = JSON.parse(auth.access);
      return access;
    }
  }
  return [];
};

let cachedAccessMap = null;

const getAccessType = (accessKey) => {
  if (!accessKey) return null;
  if (!cachedAccessMap) {
    const auth = JSON.parse(localStorage.getItem("auth_info"));
    if (auth?.company_user_access?.length) {
      cachedAccessMap = new Map(
        auth.company_user_access.map(item => [item.access, item.type])
      );
    } else {
      cachedAccessMap = new Map();
    }
  }
  return cachedAccessMap.get(accessKey) || null;
};

const convertToUpperCase = (value) => {
  return value.toUpperCase();
};

function objectToFormData(obj) {
  const formData = new FormData();
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      obj[key].forEach((value, i) => {
        formData.append(`${key}[${i}]`, value);
      });
    } else if (obj[key] !== undefined && obj[key] !== null) {
      formData.append(key, obj[key]);
    }
  }
  return formData;
}

const convertNumberToWords = (amountToWord, companyCurrency) => {
  var words = new Array();
  words[0] = "";
  words[1] = "ONE";
  words[2] = "TWO";
  words[3] = "THREE";
  words[4] = "FOUR";
  words[5] = "FIVE";
  words[6] = "SIX";
  words[7] = "SEVEN";
  words[8] = "EIGHT";
  words[9] = "NINE";
  words[10] = "TEN";
  words[11] = "ELEVEN";
  words[12] = "TWELVE";
  words[13] = "THIRTEEN";
  words[14] = "FOURTEEN";
  words[15] = "FIFTEEN";
  words[16] = "SIXTEEN";
  words[17] = "SEVENTEEN";
  words[18] = "EIGHTEEN";
  words[19] = "NINETEEN";
  words[20] = "TWENTY";
  words[30] = "THIRTY";
  words[40] = "FORTY";
  words[50] = "FIFTY";
  words[60] = "SIXTY";
  words[70] = "SEVENTY";
  words[80] = "EIGHTY";
  words[90] = "NINETY";

  if (amountToWord == null || isNaN(amountToWord)) return "Zero";

  let isNegative = false;
  if (amountToWord < 0) {
    isNegative = true;
    amountToWord = Math.abs(amountToWord);
  }

  let amount = amountToWord.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";

  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (let i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (let i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    let value = "";
    for (let i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "CRORES ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "LAKHS ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "THOUSAND ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "HUNDRED AND ";
      } else if (i == 6 && value != 0) {
        words_string += "HUNDRED ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }

  // Handling decimal values
  let decimalWords = "";
  if (atemp.length > 1) {
    let decimal = atemp[1].padEnd(2, "0").slice(0, 2);
    let decimalNum = parseInt(decimal);

    if (decimalNum !== 0) {
      decimalWords = words[decimalNum]
        ? words[decimalNum]
        : words[Math.floor(decimalNum / 10) * 10] +
        " " +
        words[decimalNum % 10];
    }
  }

  let currency = companyCurrency || store?.getState()?.authInfo?.currency || "USD";

  let decimalUnits = {
    USD: "CENTS",
    EUR: "CENTS",
    GBP: "PENCE",
    INR: "PAISE",
    JPY: "SEN",
    AED: "FILS",
    SAR: "HALALA",
    KWD: "FIL",
    BHD: "FIL",
    OMR: "BAISA",
  };
  let decimalUnit = decimalUnits[currency] || "CENTS";

  let finalWords = `${words_string.trim()} (${currency}) `;
  if (decimalWords) {
    finalWords += ` AND ${decimalWords} (${decimalUnit})`;
  }

  if (isNegative) {
    finalWords = `MINUS ${finalWords}`;
  }

  return `${finalWords} ONLY`;
};

const checkAuthBranchWare = (branchID) => {
  if (authInfoSeter.userInfo.branch_id == branchID) {
    return true;
  } else {
    return false;
  }
};

const checkIntNum = (number) => {
  return !Number.isInteger(parseFloat(number)) ? true : false;
};

let getDateTimeFromISODT = (isoString) => {
  var date = moment(isoString);
  var dateComponent = date.utc().format("Y-MM-DD");
  var timeComponent = date.utc().format("hh:mm");
  return dateComponent + "T" + timeComponent;
};

// const currentDateTime = () => {
//   return moment().toISOString();
// };
const currentDateTimeUtc = () => {
  let tz =
    JSON.parse(localStorage.getItem("auth_info"))?.time_zone || "Asia/Dubai";
  if (typeof tz === "string") {
    tz = tz.replace(/^"(.*)"$/, "$1");
  }
  return moment.tz(new Date(), tz).format("YYYY-MM-DDTHH:mm:ss");
};
const currentDateTime = () => {
  let tz =
    JSON.parse(localStorage.getItem("auth_info"))?.time_zone || "Asia/Dubai";
  if (typeof tz === "string") {
    tz = tz.replace(/^"(.*)"$/, "$1");
  }
  return moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
};

const currentYear = () => {
  return moment().year();
};

const currentMonth = () => {
  return moment().format("MMMM");
};
let timeZone = JSON.parse(localStorage.getItem("auth_info"));

let today = dayjs().format("YYYY-MM-DD");
const pureToday = dayjs(today);

const currentDateStartTime = (dateInput) => {
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";
  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }
  if (!dateInput) return null; // ✅ guard against undefined
  const date =
    typeof dateInput.format === "function" ? dateInput : dayjs(dateInput); // Fallback in case it's a Date object

  return moment
    .tz(date.format("YYYY-MM-DD"), timeZone)
    .startOf("day")
    .toISOString();
};

const currentDateEndTime = (dateInput) => {
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";
  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }
  if (!dateInput) return null;
  const date =
    typeof dateInput.format === "function" ? dateInput : dayjs(dateInput);
  return moment
    .tz(date.format("YYYY-MM-DD"), timeZone)
    .endOf("day")
    .toISOString();
};

const currentDateStartTime2 = (dateInput) => {
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let tz = authInfo?.time_zone || "Asia/Dubai";

  if (!dateInput) return null;

  const dateStr =
    typeof dateInput.format === "function"
      ? dateInput.format("YYYY-MM-DD")
      : dayjs(dateInput).format("YYYY-MM-DD");

  return moment.tz(`${dateStr} 00:00:00`, tz).toISOString();
};

const currentDateEndTime2 = (dateInput) => {
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let tz = authInfo?.time_zone || "Asia/Dubai";

  if (!dateInput) return null;

  const dateStr =
    typeof dateInput.format === "function"
      ? dateInput.format("YYYY-MM-DD")
      : dayjs(dateInput).format("YYYY-MM-DD");

  return moment.tz(`${dateStr} 23:59:59`, tz).toISOString();
};

const formatToCompanyTimezone = (dateStr) => {
  if (!dateStr) return "";
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";
  // Remove accidental double quotes saved in DB
  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }
  // Detect ISO format: 2025-09-19T10:28:47.000Z
  const isISO = typeof dateStr === "string" && dateStr.includes("T");
  let m;
  if (isISO) {
    // ✔ ISO → Parse automatically as UTC
    m = moment.utc(dateStr);
  } else {
    // ✔ Non-ISO → Always parse as YYYY-MM-DD HH:mm:ss
    // backend sends format: 2025-11-13 07:51:57
    m = moment.utc(dateStr, "YYYY-MM-DD HH:mm:ss", true);
  }
  // If parsing failed, return raw date
  if (!m.isValid()) {
    console.warn("Invalid date parsed:", dateStr);
    return dateStr;
  }
  return m.tz(timeZone).format("DD-MM-YYYY HH:mm:ss");
};

// Same UTC-to-institution-timezone conversion as formatToCompanyTimezone,
// but for date-only displays (no time component) with a configurable
// format — added because several "View details" modals were formatting
// raw UTC date values with a plain dayjs(value).format(...), which silently
// uses the VIEWER's own browser/OS timezone instead of the institution's
// configured one. That only surfaces as a visible bug when a viewer is
// physically in a different timezone than the institution (e.g. HR in
// Dubai reviewing an India-based institution's records), showing a date one
// day off from the same record's correctly-converted table cell.
const formatToCompanyDate = (dateStr, format = "DD-MMM-YYYY") => {
  if (!dateStr) return "";
  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";
  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }
  const isISO = typeof dateStr === "string" && dateStr.includes("T");
  const m = isISO
    ? moment.utc(dateStr)
    : moment.utc(dateStr, "YYYY-MM-DD HH:mm:ss", true);
  if (!m.isValid()) {
    console.warn("Invalid date parsed:", dateStr);
    return dateStr;
  }
  return m.tz(timeZone).format(format);
};

export const convertToCompanyTimezoneObject = (dateStr) => {
  if (!dateStr) return moment.invalid();

  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";

  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }

  const isISO =
    typeof dateStr === "string" &&
    dateStr.includes("T");

  const m = isISO
    ? moment.utc(dateStr)
    : moment.utc(dateStr, "YYYY-MM-DD HH:mm:ss", true);

  return m.tz(timeZone);
};


// remove time string and keep only date to format in DD/MM/YYYY
// export const formatDateOnly = (dateStr) => {
//   if (!dateStr) return "";
//   return moment(dateStr).tz(timeZone).format("DD-MMM-YYYY");
// };

export const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";

  const parsed = moment(
    dateStr,
    [
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601
    ],
    true
  );

  return parsed.isValid()
    ? parsed.format("DD-MMM-YYYY")
    : "";
};

export const formatDateOnlyForAdvance = (dateStr) => {
  if (!dateStr) return "";

  return moment(
    dateStr,
    [
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY-MM-DD HH:mm:ss"
    ],
    true
  ).format("DD-MMM-YYYY");
};

export const formatNonUTCDateOnly = (dateStr) => {
  if (!dateStr) return "";
  return moment(dateStr).format("DD-MMM-YYYY");
};

const toCompanyDateOnlyforReportDateFilter = (iso) => {
  if (!iso) return null;

  const authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let tz = authInfo?.time_zone || "Asia/Dubai";
  if (typeof tz === "string") tz = tz.replace(/^"(.*)"$/, "$1");

  // Convert UTC → company TZ → date-only
  return dayjs(
    moment.utc(iso).tz(tz).format("YYYY-MM-DD")
  );
};

let authInfo = JSON.parse(localStorage.getItem("auth_info"));
timeZone = authInfo?.time_zone || "Asia/Dubai";

if (typeof timeZone === "string") {
  timeZone = timeZone.replace(/^"(.*)"$/, "$1");
}

const formatToUtc = (date) => {
  let authInfo = JSON.parse(localStorage?.getItem("auth_info"));
  timeZone = authInfo?.time_zone || "Asia/Dubai";

  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }
  return moment.tz(date, timeZone).utc().format("YYYY-MM-DD HH:mm:ss");
};

const formatToUtcString = (date, timeZone) => {
  return moment.tz(date, timeZone).utc().format("YYYY-MM-DD HH:mm:ss");
};

export const formatDayjsToUtc = (date) => {
  let authInfo = JSON.parse(localStorage.getItem("auth_info"));
  let timeZone = authInfo?.time_zone || "Asia/Dubai";

  if (typeof timeZone === "string") {
    timeZone = timeZone.replace(/^"(.*)"$/, "$1");
  }

  return moment
    .tz(
      date.format("YYYY-MM-DD HH:mm:ss"),
      "YYYY-MM-DD HH:mm:ss",
      timeZone
    )
    .utc()
    .format("YYYY-MM-DD HH:mm:ss");
};

/**
 * Returns selected date with current time in company time zone (non-UTC).
 * @param {Date | string} dateOnly - Date selected from UI
 * @returns {string} - Combined datetime string in company timezone, e.g. '2025-03-24T14:36:22'
 */
const getDateTimeFromSelectedDate = (dateOnly) => {
  let tz =
    JSON.parse(localStorage.getItem("auth_info"))?.time_zone || "Asia/Dubai";
  if (typeof tz === "string") {
    tz = tz.replace(/^"(.*)"$/, "$1");
  }
  let date;
  // Handle various formats (dayjs, moment, Date, string)
  if (dateOnly && typeof dateOnly.format === "function") {
    // Could be dayjs or moment
    date = dayjs(dateOnly.format("YYYY-MM-DD"));
  } else if (dateOnly instanceof Date) {
    date = dayjs(dateOnly);
  } else if (typeof dateOnly === "string") {
    date = dayjs(dateOnly);
  } else {
    return null; // invalid input
  }

  if (!date?.isValid()) return null;
  const selectedDate = date.format("YYYY-MM-DD");
  // const currentTime = moment().tz(tz).format("HH:mm:ss");  
  const currentTime = moment().tz(tz).format("HH:mm:ss");
  return `${selectedDate}T${currentTime}`;
};

const _p = (prom) => {
  return new Promise(function (resolve, reject) {
    let error = null;
    let data = null;
    prom
      .then((d) => {
        data = d.data;
        resolve([error, data]);
      })
      .catch((e) => {
        error = e;
        resolve([error, data]);
      });
  });
};

const sleep = (delay = 0) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};

const nextTotalDaysOfMonth = (totalMonth, created_date) => {
  // Get current date
  const currentDate = new Date(created_date);

  let month = 0;

  // Loop through the next 5 months and get the total number of days for each month
  for (let i = 0; i < totalMonth; i++) {
    // Get the month and year for the next iteration
    let nextMonth = currentDate.getMonth() + i + 1;
    let nextYear = currentDate.getFullYear();

    // Handle the case WHERE the next month is in the next year
    if (nextMonth > 11) {
      nextMonth = 0;
      nextYear = nextYear + 1;
    }

    // Get the total number of days for the next month
    const totalDays = new Date(nextYear, nextMonth + 1, 0).getDate();

    // Log the result

    month = month + parseFloat(totalDays);
  }

  return month;
};

const nextTotalWeekOfMonth = (totalMonth, created_date) => {
  let month = 0;

  // Get current date
  const currentDate = new Date(created_date);

  // Loop through the next 5 months and get the total number of weeks for each month
  for (let i = 0; i < 5; i++) {
    // Get the month and year for the next iteration
    let nextMonth = currentDate.getMonth() + i + 1;
    let nextYear = currentDate.getFullYear();

    // Handle the case WHERE the next month is in the next year
    if (nextMonth > 11) {
      nextMonth = 0;
      nextYear = nextYear + 1;
    }

    // Get the first and last day of the next month
    const firstDay = new Date(nextYear, nextMonth, 1);
    const lastDay = new Date(nextYear, nextMonth + 1, 0);

    // Calculate the total number of weeks for the next month
    const totalWeeks = Math.ceil(
      (lastDay.getDate() - firstDay.getDate() + 1 + firstDay.getDay()) / 7
    );

    // Log the result

    month = month + parseFloat(totalWeeks);
  }

  return month;
};

let setLifetimeCookie = (name, value) => {
  // Set the expiration date to a very distant future
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 10); // Set to expire in 10 years

  const cookieString = `${name}=${encodeURIComponent(
    value
  )}; expires=${expirationDate.toUTCString()}; path=/`;
  document.cookie = cookieString;
};

let getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null; // Cookie not found
};

const currentDayIndex = () => {
  const currentDate = new Date();
  const currentDayIndex = currentDate.getDay();

  return currentDayIndex;
};

const getCollectionDailys = (weekday, month, year) => {
  const days = [];
  const date = new Date(year, month, 1);

  while (date.getMonth() === month) {
    if (date.getDay() !== weekday) {
      // Check if the day is not Friday (5)
      days.push(new Date(date)); // Clone the date to avoid modifying the original date object
    }
    date.setDate(date.getDate() + 1); // Move to the next day
  }

  return days;
};

const getCollectionDays = (day, month, year) => {
  const days = [];
  const date = new Date(year, month, 1);

  while (date.getMonth() === month) {
    if (date.getDay() === day) {
      // Friday is represented by 5 (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
      days.push(new Date(date)); // Clone the date to avoid modifying the original date object
    }
    date.setDate(date.getDate() + 1); // Move to the next day
  }

  return days;
};

const timeOnlyConversion = (time) => {
  if (time) {
    // Combine dummy date with selected time, assume it's in company timezone
    const timeInCompanyTz = moment.tz(
      time.format("HH:mm:ss"),
      "HH:mm:ss",
      timeZone
    );
    return timeInCompanyTz.toISOString();
  }
};

const dateOnlyConversion = (date) => {
  if (date) {
    const timeInCompanyTz = moment.tz(
      date.format("YYYY-MM-DD HH:mm:ss"),
      "YYYY-MM-DD HH:mm:ss",
      timeZone
    );
    return timeInCompanyTz.toISOString();
  }
};

const numberFormat = (value) => {
  if (value == null || value === "") return "0.00";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value));
};

const numberFormatTax = (value) => {
  if (value == null || value === "") return "0.00";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(Number(value));
};


const monthWiseForamatedDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return formattedDate;
};

// 🧠 Utility: format snake_case → Title Case
const formatTitleCaseLabel = (key) => {
  if (!key) return "";
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getYearFromCompanyDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;


  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return Number(dateStr.substring(0, 4));
  }


  if (/^\d{2}-\d{2}-\d{4}/.test(dateStr)) {
    return Number(dateStr.substring(6, 10));
  }

  return null;
}

// reusable helper for direct download print
export async function downloadPdfFromRef(saleId, fileName) {
  const res = await renderPdfApi(
    { url: `/print/sales/${saleId}`, fileName },
    { responseType: 'blob' }
  );

  const blob = new Blob([res.data], { type: "application/pdf" });

  const urlObj = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = urlObj;
  a.download = fileName || 'invoice.pdf';
  document.body.appendChild(a);  // ← add to DOM (required in some browsers)
  a.click();
  document.body.removeChild(a);  // ← clean up
  window.URL.revokeObjectURL(urlObj);
}

// Universal ERP PDF downloader
export async function downloadPdf(urlPath, fileName = "document.pdf") {
  if (!urlPath) return;

  // sanitize filename 
  const safeName = fileName.replace(/[/\\?%*:|"<>]/g, "-");

  const res = await renderPdfApi({
    url: urlPath,
    fileName: safeName,
  });

  const blob = new Blob([res.data], { type: "application/pdf" });

  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = safeName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(downloadUrl);
}

let Trial_Limits = {
  invoice_count: 100,
  product_count: 10,
  employee_count: 1,
  branch_count: 1,
  user_count: 1,
};

export const generatePdfBlob = async (element) => {
  if (!element) return null;

  // wait layout settle
  await new Promise(r => setTimeout(r, 300));

  // Size the PDF page to the element's own rendered aspect ratio (it's already
  // laid out at A4 proportions via CSS) instead of a fixed "a4" format. A fixed
  // format hands off pagination to html2pdf's page-break slicer, and a
  // sub-pixel mm->px rounding mismatch there is enough to spill a near-blank
  // second page.
  const pageWidthMm = 210;
  const pageHeightMm =
    (element.scrollHeight / element.scrollWidth) * pageWidthMm || 297;

  const opt = {
    margin: 0,
    filename: "invoice.pdf",
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight
    },
    jsPDF: {
      unit: "mm",
      format: [pageWidthMm, pageHeightMm],
      orientation: "portrait"
    },
    pagebreak: { mode: ["css", "legacy"] }
  };

  return await html2pdf().set(opt).from(element).outputPdf("blob");
};

 const calculateDistanceMeters = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3;
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// used in text area for terms & conditions in settings and quotation and PO pages
const formatBulletText = (text = "") => {
  return text
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();

      if (!trimmed) return "";

      return trimmed.startsWith("•")
        ? trimmed
        : `• ${trimmed}`;
    })
    .join("\n");
};


  const isAdmin = (authInfo) => {
  const roles =
    authInfo?.userInfo?.user_role_names || "";
  return roles.toLowerCase().includes("_admin");
};


export {
  pathSpliter,
  _p,
  sleep,
  authInfoSeter,
  convertNumberToWords,
  accessChecker,
  accessList,
  getAccessType,
  checkAuthBranchWare,
  dateTimeFormat,
  dateFormat,
  checkIntNum,
  currentDateTime,
  getDateTimeFromISODT,
  pureToday,
  currentDateStartTime,
  currentDateStartTime2,
  currentDateEndTime,
  currentDateEndTime2,
  formatToCompanyTimezone,
  formatToCompanyDate,
  toCompanyDateOnlyforReportDateFilter,
  formatToUtc,
  formatToUtcString,
  currentDateTimeUtc,
  getDateTimeFromSelectedDate,
  dateWithTimeFormat,
  currentYear,
  currentMonth,
  nextTotalDaysOfMonth,
  nextTotalWeekOfMonth,
  setLifetimeCookie,
  getCookie,
  currentDayIndex,
  getCollectionDailys,
  getCollectionDays,
  convertToUpperCase,
  timeOnlyConversion,
  dateOnlyConversion,
  objectToFormData,
  numberFormat,
  monthWiseForamatedDate,
  formatTitleCaseLabel,
  getYearFromCompanyDate,
  numberFormatTax,
  Trial_Limits,
  calculateDistanceMeters,
  formatBulletText,
  isAdmin,
};
